//#region Icons
import { RESOURCES_CONSTANTS } from "config/constants";
//#endregion

const { RESOURCE_TYPES_IDS } = RESOURCES_CONSTANTS;
export const HEADERS_TABLE_LIST = {
    [RESOURCE_TYPES_IDS.TABLET]: [
        { title: "Marca" },
        { title: "Modelo" },
        { title: "Serie" },
        { title: "Código de barras" },
        { title: "Detalles" },
        { title: "Fecha" },
        { title: "Hora" }
    ],
    [RESOURCE_TYPES_IDS.PC]: [
        { title: "Marca" },
        { title: "Código de barras" },
        { title: "Detalles" },
        { title: "Fecha" },
        { title: "Hora" }
    ],
    [RESOURCE_TYPES_IDS.GROUP_ROOM]: [
        { title: "Cantidad máxima de alumnos" },
        { title: "Nombre" },
        { title: "Dirección" },
        { title: "Detalles" },
        { title: "Fecha" },
        { title: "Hora" }
    ]
};